import React from "react";
import { connect } from "react-redux";
import { Modal, Form, Icon, Layout, List, Switch, message } from "antd";
import { withNamespaces } from "react-i18next";
import get from "lodash/get";

import EditConfigForm from "./EditConfigForm";
import classes from "./SamlConfig.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { logout } from "../../reducers/user/actions";
import {
  getSamlConfigsRequest,
  getSettingsRolesRequest,
  getSitesRequest,
  samlConfigActivate,
  samlConfigInactivate,
} from "../../api/requests";
import {
  getSamlConfigUpdatePermission,
  getSamlConfigActivatePermission,
  getSamlConfigInactivatePermission,
} from "../../reducers/user/selectors";

const { Content } = Layout;

class SamlConfig extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      samlConfigData: [],
      roles: [],
      sites: [],
      isLoadingData: true,
      editConfig: null,
      isLoadingActivation: null,
    };
  }

  componentDidMount() {
    this.getConfigData();
    this.getSitesRoles();
  }

  getConfigData = async () => {
    this.getSamlConfig();
  };

  getSitesRoles = async () => {
    try {
      const { data } = await getSettingsRolesRequest();
      const { data: sites } = await getSitesRequest();
      this.setState({ roles: data, sites });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  };

  getSamlConfig = async () => {
    this.setState({
      isLoadingData: true,
    });

    try {
      const { data: samlConfigData } = await getSamlConfigsRequest();
      this.setState({
        samlConfigData: samlConfigData.sort((a, b) => a.id - b.id),
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({
      isLoadingData: false,
    });
  };

  onSwitchActivation = (state, id) => async () => {
    this.setState({ isLoadingActivation: id });

    try {
      if (state === "active") {
        await samlConfigInactivate(id);
      } else {
        await samlConfigActivate(id);
      }

      message.success(this.props.i18n.t("Saved"));

      await this.getConfigData();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
    }

    this.setState({ isLoadingActivation: null });
  };

  render() {
    const {
      samlConfigData,
      isLoadingData,
      editConfig,
      isLoadingActivation,
    } = this.state;

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <div>
              <h3 className="headline-default">SAML Config</h3>

              <List
                itemLayout="horizontal"
                dataSource={samlConfigData}
                loading={isLoadingData}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      title={
                        <div>
                          <a
                            onClick={() => {
                              this.setState({ editConfig: item });
                            }}
                            style={{ color: "#444" }}
                          >
                            {item.type_name} <Icon type="edit" />
                          </a>

                          <Switch
                            disabled={
                              isLoadingActivation === item.id ||
                              (item.state === "active" &&
                                !this.props
                                  .getSamlConfigInactivatePermission) ||
                              (item.state === "inactive" &&
                                !this.props.getSamlConfigActivatePermission)
                            }
                            loading={isLoadingActivation === item.id}
                            className={classes.activateBtn}
                            checked={item.state === "active"}
                            onChange={this.onSwitchActivation(
                              item.state,
                              item.id
                            )}
                          />
                        </div>
                      }
                      description={item.metadata_url}
                    />
                  </List.Item>
                )}
              />
            </div>
          </Content>
        </Layout>

        <Modal
          visible={!!editConfig}
          footer={null}
          title={`Edit config`}
          onCancel={() => {
            this.setState({ editConfig: null });
          }}
        >
          {!!editConfig && (
            <EditConfigForm
              configData={editConfig}
              sites={this.state.sites}
              roles={this.state.roles}
              isEditable={this.props.getSamlConfigUpdatePermission}
              onSubmit={() => {
                this.setState({ editConfig: null }, this.getConfigData);
              }}
              onCancel={() => {
                this.setState({ editConfig: null });
              }}
            />
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  getSamlConfigUpdatePermission: getSamlConfigUpdatePermission(state),
  getSamlConfigActivatePermission: getSamlConfigActivatePermission(state),
  getSamlConfigInactivatePermission: getSamlConfigInactivatePermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  Form.create({ name: "randomizationConfig" })(
    connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SamlConfig))
  )
);



// WEBPACK FOOTER //
// ./src/containers/SamlConfig/SamlConfig.js